import React from 'react';
import { AuthProvider } from '../context/AuthContext';
import { PaymentProvider } from '../context/PaymentContext';
import { NotificationProvider } from '../components/notifications/NotificationSystem';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CurrencyProvider } from '../context/CurrencyContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#cf1130',
    },
  },
});

const AppProvider = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CurrencyProvider>
        <AuthProvider>
          <PaymentProvider>
            <NotificationProvider>
              {children}
            </NotificationProvider>
          </PaymentProvider>
        </AuthProvider>
      </CurrencyProvider>
    </ThemeProvider>
  );
};

export default AppProvider;